module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Assign application"},"da":{"title":"Tildel applikation"}}')
  delete Component.options._Ctor
}
